import React, { useState, useEffect } from 'react';
import { Table, Dimmer, Segment, Loader, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { iRootState } from '../../../../store';
import IconButton from '../../../../components/IconButton';
import { ClickableTableCell, SelectableTableRow } from '../../../../styles';
import { FranchiseState } from '../../../../types/FranchiseState';
import { maskCpfOrCnpj } from '../../../../services/masks';
import { Header, NotFoundWrapper, TableComponent, TableWrapper } from './styles';
import AuthorizationContainer from '../../../../components/AuthorizationContainer';
import { FeatureEnum } from '../../../../enums/authz-feature.enum';
import { ActionEnum } from '../../../../enums/authz-action.enum';
import { useHistory } from 'react-router-dom';
import { statusOptions } from '../../types';
import TablePaginationMenu from '../../../../components/TablePaginationMenu';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapState = (state: iRootState) => ({
  user: state.user,
  availableBrokersAndEstates: state.availableBrokersAndEstates
});

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatch = () => ({});

type Props = {
  franchises: FranchiseState[] | [];
  isLoading: boolean;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  dataCount: number;
  handleSelectItem: (franchise: FranchiseState) => void;
} & ReturnType<typeof mapState>;

const FranchiseListPageTable = (props: Props): JSX.Element => {
  const {
    franchises,
    isLoading,
    currentPage,
    setCurrentPage,
    dataCount,
    handleSelectItem
  } = props;

  const [listData, setListData] = useState<FranchiseState[]>([]);
  const history = useHistory();

  useEffect(() => {
    setListData(franchises);
  }, [franchises]);

  function renderTableData(franchises: Array<FranchiseState>): Array<JSX.Element> {
    const trigger = (
      <AuthorizationContainer action={ActionEnum.update} feature={FeatureEnum.policies}>
        <IconButton name="ellipsis vertical" />
      </AuthorizationContainer>
    );
    return franchises.map((franchise: FranchiseState) => {
      return (
        <SelectableTableRow key={franchise?.id}>
          <ClickableTableCell onClick={() => handleSelectItem(franchise)}>
            {franchise?.name}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(franchise)}>
            {maskCpfOrCnpj(franchise?.document)}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(franchise)}>
            {franchise?.street}, {franchise?.city} ({franchise?.state})
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(franchise)}>
            {franchise?.responsible_name}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(franchise)}>
            {franchise?.email}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(franchise)}>
            {franchise?.accountManager?.name}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(franchise)}>
            {statusOptions.find(status => status.value === franchise?.status)?.text}
          </ClickableTableCell>

          <ClickableTableCell width={1} textAlign={'right'}>
            <Dropdown trigger={trigger} icon={null} direction="left">
              <Dropdown.Menu>
                <Dropdown.Item
                  icon="pencil"
                  text={'Editar Parceiro'}
                  onClick={() => history.push(`/admin/franchise/${franchise?.id}`)}
                />
              </Dropdown.Menu>
            </Dropdown>
          </ClickableTableCell>
        </SelectableTableRow>
      );
    });
  }

  return (
    <TableComponent>
      <Dimmer.Dimmable as={Segment} dimmed={isLoading}>
        <Dimmer active={isLoading} inverted>
          <Loader />
        </Dimmer>
        {listData && listData.length > 0 ? (
          <TableWrapper>
            <Table>
              <Header>
                <Table.Row>
                  <Table.HeaderCell>NOME / RAZÃO SOCIAL</Table.HeaderCell>
                  <Table.HeaderCell>CPF/CNPJ</Table.HeaderCell>
                  <Table.HeaderCell>ENDEREÇO</Table.HeaderCell>
                  <Table.HeaderCell>RESPONSÁVEL</Table.HeaderCell>
                  <Table.HeaderCell>E-MAIL DA UNIDADE</Table.HeaderCell>
                  <Table.HeaderCell>GESTOR DE CONTAS</Table.HeaderCell>
                  <Table.HeaderCell>STATUS</Table.HeaderCell>
                  <Table.HeaderCell width={1} textAlign={'right'}>
                    <IconButton name="setting" />
                  </Table.HeaderCell>
                </Table.Row>
              </Header>
              <Table.Body>{renderTableData(franchises)}</Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="17">
                    <TablePaginationMenu
                      currentPage={currentPage}
                      dataCount={dataCount}
                      setCurrentPage={setCurrentPage}
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </TableWrapper>
        ) : (
          <NotFoundWrapper>
            <p>Parceiros não encontrados</p>
          </NotFoundWrapper>
        )}
      </Dimmer.Dimmable>
    </TableComponent>
  );
};

export default connect(mapState, mapDispatch)(FranchiseListPageTable);
